import { FlirtingStyleOptionsType } from './types';

export const FLIRTING_STYLE_OPTIONS: FlirtingStyleOptionsType = [
  { id: 'bold_teasing', title: 'Bold & teasing' },
  { id: 'shy_intense', title: 'Shy but intense' },
  { id: 'cheeky_sarcastic', title: 'Cheeky & sarcastic' },
  { id: 'gentle_slow', title: 'Gentle & slow-burning' },
];
